export const vaultActions = {

    GET_VAULT_TYPES: 'GET_VAULT_TYPES',
    SET_VAULT_TYPES: 'SET_VAULT_TYPES',

    GET_VAULTS: 'GET_VAULTS',
    SET_VAULTS: 'SET_VAULTS',
    GET_VAULT_BY_ID: 'GET_VAULT_BY_ID',
    SET_VAULT_BY_ID: 'SET_VAULT_BY_ID',

    GET_VAULT_CONFIGURATION: 'GET_VAULT_CONFIGURATION',
    SET_VAULT_CONFIGURATION: 'SET_VAULT_CONFIGURATION',
    UPDATE_VAULT_CONFIGURATION: 'UPDATE_VAULT_CONFIGURATION',
    DELETE_VAULT_CONFIGURATION: 'DELETE_VAULT_CONFIGURATION',

    GET_VAULTS_WITH_CREDENTIALS: 'GET_VAULTS_WITH_CREDENTIALS',
    SET_VAULTS_WITH_CREDENTIALS: 'SET_VAULTS_WITH_CREDENTIALS',
    GET_VAULT_CREDENTIALS: 'GET_VAULT_CREDENTIALS',
    GET_VAULT_CONNECTION: 'GET_VAULT_CONNECTION',
    TEST_VAULT_CONNECTION: 'TEST_VAULT_CONNECTION',

    REFRESH_DELETE_VAULT: 'REFRESH_DELETE_VAULT',
    POST_VAULT_CREDENTIALS: 'POST_VAULT_CREDENTIALS',
    POST_VAULT_CONNECTION: 'POST_VAULT_CONNECTION',
    REUSLT_TEST_VAULT_CONNECTION: 'REUSLT_TEST_VAULT_CONNECTION',

};

const initState = {
    vaults: [],
    vault_types: [],
    vault_configuration: [],
    vaults_with_credentials: [],
    test: {},
    vault: {}

};

export const vaultReducer = (state = initState, action: any) => {
    switch (action.type) {
    case vaultActions.SET_VAULT_TYPES:
        return Object.assign({}, state, { vault_types: action.payload });

    case vaultActions.SET_VAULTS:
        return Object.assign({}, state, { vaults: action.payload });
    case vaultActions.SET_VAULTS_WITH_CREDENTIALS:
        return Object.assign({}, state, { vaults_with_credentials: action.payload });
    case vaultActions.SET_VAULT_BY_ID:
        return Object.assign({}, state, { vault: action.payload });
    case vaultActions.REUSLT_TEST_VAULT_CONNECTION:
        return Object.assign({}, state, { test: action.payload });
    case vaultActions.REFRESH_DELETE_VAULT:
        const indexOfDeletedVault = state.vaults.findIndex(value => value.ID === action.payload);
        const vaultExist = state.vaults.filter((item: any) => item.ID !== action.payload);
        const newSelectedVault = (indexOfDeletedVault !== -1 && vaultExist.length > indexOfDeletedVault) ?
            indexOfDeletedVault : 0;
        return Object.assign({}, state, {
            vaults: vaultExist || null,
            vault: vaultExist ? vaultExist[newSelectedVault] : null
        });

    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/vaultReducer.ts